export const BLOCK_SELECTOR = '[data-page-path="page.block"]';
export const TILE_SELECTOR = '[data-page-path="page.tile"], [data-page-path="page.link"]';
/** Site header blocks only — viewer icons / logo / video chrome belong to Viewer and Video. */
export const HEADER_MODULE_SELECTOR = '[data-header-module]:not([data-header-module^="icon-"]):not([data-header-module^="video-"]):not([data-header-module="viewer-logo"])';
/** Dashed Inspect outlines per tab. Header / Viewer / Video draw their own move frames. */
export const INSPECT_TARGETS = [
    { group: 'page', targets: ['[data-page-path]'] },
    { group: 'colour', targets: ['[data-theme-path^="colors."]'] },
    { group: 'type', targets: ['[data-theme-path^="fonts."]', '[data-theme-path^="type."]'] },
    { group: 'chrome', targets: ['[data-theme-path^="chrome."]', '[data-theme-path^="layout."]'] },
    { group: 'header', targets: ['[data-theme-path^="header."]:not([data-header-module])', '[data-theme-path^="menu."]'] },
];

export const VIEWER_CHROME_SELECTORS = [
    '[data-header-module^="icon-"]',
    '[data-header-module="viewer-logo"]',
    '[data-header-module="media-title"]',
];
export const MEDIA_FRAME_SELECTOR = '[data-header-module="media-frame"]';
export const VIDEO_CHROME_SELECTORS = ['[data-header-module^="video-"]'];

// `resizable` kinds get the overlay's corner resize handle.
export const INSPECT_KINDS = Object.freeze([
    {
        id: 'header-module',
        tab: 'header',
        selectors: [HEADER_MODULE_SELECTOR],
        idle: 'module',
        movable: true,
        resizable: true,
    },
    {
        id: 'viewer-chrome',
        tab: 'viewer',
        selectors: VIEWER_CHROME_SELECTORS,
        idle: 'module',
        movable: true,
        resizable: false,
    },
    {
        id: 'media-frame',
        tab: 'viewer',
        selectors: [MEDIA_FRAME_SELECTOR],
        idle: 'module',
        movable: false,
        resizable: true,
    },
    {
        id: 'video-chrome',
        tab: 'video',
        selectors: VIDEO_CHROME_SELECTORS,
        idle: 'module',
        movable: true,
        resizable: false,
    },
    {
        id: 'page-block',
        tab: 'page',
        selectors: [BLOCK_SELECTOR],
        idle: 'page',
        movable: false,
        resizable: false,
    },
    {
        id: 'page-content',
        tab: 'page',
        selectors: [
            `[data-page-path="page.content"]:not(${BLOCK_SELECTOR} *)`,
            `[data-page-path="page.grid"]:not(${BLOCK_SELECTOR} *)`,
        ],
        idle: 'page',
        movable: false,
        resizable: false,
    },
    {
        id: 'colour',
        tab: 'colour',
        selectors: ['[data-theme-path^="colors."]'],
        idle: 'token',
        movable: false,
        resizable: false,
    },
    {
        id: 'type',
        tab: 'type',
        selectors: ['[data-theme-path^="fonts."]', '[data-theme-path^="type."]'],
        idle: 'token',
        movable: false,
        resizable: false,
    },
    {
        id: 'chrome',
        tab: 'chrome',
        selectors: ['[data-theme-path^="chrome."]', '[data-theme-path^="layout."]'],
        idle: 'token',
        movable: false,
        resizable: false,
    },
]);

const KIND_BY_ID = new Map(INSPECT_KINDS.map((kind) => [kind.id, kind]));

export function kindById(id) {
    return KIND_BY_ID.get(id) || null;
}

export function kindsForTab(tab) {
    return INSPECT_KINDS.filter((kind) => kind.tab === tab);
}

export function kindForModuleId(moduleId) {
    const key = String(moduleId || '');
    if (key.startsWith('video-')) return 'video-chrome';
    if (key === 'media-frame') return 'media-frame';
    if (key === 'media-title' || key.startsWith('icon-') || key === 'viewer-logo') return 'viewer-chrome';
    return 'header-module';
}
